
import AuthService from '../../../services/auth/AuthService'
import ApiService from '../../../services/ApiService'
import * as jwt_decode from "jwt-decode";
import router from '../../../router/index';
import { registerDynamicRoutes } from '../../../utils/routerUtils';
import OptionsService from '../../../services/optionsService';

export default {
  login({ dispatch, commit }, { identification, password }) {
    return new Promise((resolve, reject) => {
      commit('loginRequest', { identification })
      AuthService.login(identification, password)
        .then(response => {
          const token = response.data.accessToken
          ApiService.setHeader('authorization', `${token}`);

          const decodedToken = jwt_decode(token);
          const user = decodedToken.id;

          commit('loginSuccess', { user, token })
          resolve(response)
        })
        .catch(error => {
          commit('loginFailure', error)
          reject(error)
        })
    })
  },

  loginApp(identification, password) {
    AuthService.loginApp(identification, password)
    // .then(response => {
    //   const token = response.data.accessToken
    //   ApiService.setHeader('Authorization', `Bearer ${token}`);

    //   const decodedToken = jwt_decode(token);
    //   const user = decodedToken.id;

    //   commit('loginSuccess', { user, token })
    //   resolve(response)
    // })
    // .catch(error => {
    //   commit('loginFailure', error)
    //   reject(error)
    // })

  },

  loginToken({ dispatch, commit }, { token }) {
    return new Promise((resolve, reject) => {
      AuthService.loginToken(token)
        .then(response => {
          const authorized = response.data.authorized
          if (authorized) {
            let data = {
              identification: response.data.identification,
              identificationType: response.data.identificationtype
            }
            AuthService.requestToken(data)
              .then(response => {
                const token = response.data.accessToken
                ApiService.setHeader('authorization', `${token}`);
                const decodedToken = jwt_decode(token);
                const user = decodedToken.id;
                commit('loginSuccess', { user, token })
                resolve(response)
              })
              .catch(error => {
                commit('loginFailure', error)
                reject(error)
              })
          } else {
            reject('No authorized')
          }

        })
        .catch(error => {
          commit('loginFailure', error)
          reject(error)
        })
    })
  },

  loginToken2({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      AuthService.loginToken2()
        .then(response => {
          if (response.data !== 'No consentido') {
            const token = response.data.accessToken
            ApiService.setHeader('authorization', `${token}`);
            const decodedToken = jwt_decode(token);
            const user = decodedToken.id;
            const identification = decodedToken.identification;
            const identificationType = decodedToken.identificationType;
            commit('loginSuccess', { user, token })
            commit('saveIdentification', identification);
            commit('saveIdentificationType', identificationType);
            OptionsService.fetchOptions({ user, identification, identificationType })
              .then(optionsResponse => {
                const options = optionsResponse.data && optionsResponse.data.options ? optionsResponse.data.options : null;
                if (Array.isArray(options)) {
                  localStorage.setItem('options', JSON.stringify(options));
                  registerDynamicRoutes(router, options);
                }
                setTimeout(() => resolve(response), 0);
              })
              .catch(optionsError => {
                resolve(response);
              });
            resolve(response)
          } else if (response.data === 'No consentido') {
            resolve(response)
          }
        })
        .catch(error => {
          commit('loginFailure', error)
          reject(error)
        })
    })
  },

  loginToken3({ dispatch, commit }, { token }) {
    return new Promise((resolve, reject) => {
      
      let data = {
        token: token
      }
      AuthService.requestToken(data)
        .then(response => {
          if (response.data !== 'No consentido') {
            const token = response.data.accessToken
            ApiService.setHeader('authorization', `${token}`);
            const decodedToken = jwt_decode(token);
            const user = decodedToken.id;
            const identification = decodedToken.identification;
            const identificationType = decodedToken.identificationType;
            commit('loginSuccess', { user, token })
            commit('saveIdentification', identification);
            commit('saveIdentificationType', identificationType);
            OptionsService.fetchOptions({ user, identification, identificationType })
              .then(optionsResponse => {
                const options = optionsResponse.data && optionsResponse.data.options ? optionsResponse.data.options : null;
                if (Array.isArray(options)) {
                  localStorage.setItem('options', JSON.stringify(options));
                  registerDynamicRoutes(router, options);
                }
                setTimeout(() => resolve(response), 0);
              })
              .catch(optionsError => {
                resolve(response);
              });
            resolve(response)
          } else if (response.data === 'No consentido') {
            resolve(response)
          }
        })
        .catch(error => {
          commit('loginFailure', error)
          reject(error)
        })
    })
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
      ApiService.removeHeader()
      resolve()
    })
  },
  saveIdentification({ commit }, identification) {
    commit('saveIdentification', identification);
  }
}
